exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".product-order-container {\n  padding: 20px; }\n", ""]);

// exports
